import { render, staticRenderFns } from "./deleteCommunityPublicity.vue?vue&type=template&id=1272aeb7&scoped=true"
import script from "./deleteCommunityPublicity.vue?vue&type=script&lang=js"
export * from "./deleteCommunityPublicity.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunityPublicity.vue?vue&type=style&index=0&id=1272aeb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272aeb7",
  null
  
)

export default component.exports